function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f0b543;}.b{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  className: "a",
  cx: 47,
  cy: 47,
  r: 47
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M629.831,319.536,627.4,317.1a2.982,2.982,0,0,0-4.206-.011L606.278,332.7a3.159,3.159,0,0,0-1.058,2.149,2.992,2.992,0,0,0,.858,2.231l3.634,3.674.007.007a3.009,3.009,0,0,0,2.114.878h.11A3.129,3.129,0,0,0,614.1,340.6l15.719-16.837a2.982,2.982,0,0,0,.018-4.217Z",
  transform: "translate(-580.58 -273.767)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M649.384,314.617l-.029-.029-3.193-3.161a2,2,0,0,0-1.424-.583,2.039,2.039,0,0,0-1.192.386c0-.04.006-.079.008-.114a3.407,3.407,0,0,0-.485-2.35,24.032,24.032,0,0,0-2.311-2.678l-.008-.007a25.222,25.222,0,0,0-8.081-5.212,13,13,0,0,0-4.946-.974,9.426,9.426,0,0,0-6.033,2.113,11.168,11.168,0,0,0-1.321,1.511,1.491,1.491,0,0,0,1.738,2.268,6.933,6.933,0,0,1,.8-.245,5.913,5.913,0,0,1,1.719-.107,7.228,7.228,0,0,1,3.326,1.22,4.79,4.79,0,0,1,1.7,3.829,9.939,9.939,0,0,1-1.864,3.213,1.491,1.491,0,0,0,.135,1.957l3.206,3.206a1.491,1.491,0,0,0,2.05.058c.907-.81,2.288-2.03,2.77-2.329a3.471,3.471,0,0,1,1.37-.54,1.787,1.787,0,0,1,1.052.222.116.116,0,0,1-.029.089l-.17.161-.028.026a2.005,2.005,0,0,0-.005,2.836l.01.01,3.192,3.16a2,2,0,0,0,1.424.582,2.022,2.022,0,0,0,1.418-.578l5.171-5.108.052-.055a2.038,2.038,0,0,0-.026-2.775Z",
  transform: "translate(-580.58 -273.767)"
});

function SvgIconLabor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLabor);
export default __webpack_public_path__ + "static/media/icon_labor.409268b2.svg";
export { ForwardRef as ReactComponent };